// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  apiURL: {
    baseUrl: 'https://app.novage.ms/api/superadmin',
    systemAnalyticsApis: 'https://analyticslive.novage.ms',
    apinode18: 'https://api.novage.ms/v1/',
    serverUrl: 'https://app.novage.ms/api/',
    newBaseUrl:'https://api.novage.ms/v1/superAdmin',
    payrollUpdateBaseUrl: 'https://api.novage.ms'
  }
  // apiURL: {
  //   baseUrl: 'https://betatwo.novagems.io/api/superadmin',
  //   newBaseUrl:'https://apib2.novagems.io/v1/superAdmin',
  //   systemAnalyticsApis: 'https://analyticsb2.novagems.io',
  //   payrollUpdateBaseUrl: 'https://api.novage.ms',
  //   apinode18 : 'https://apib2.novagems.io/v1/',
  //   serverUrl: 'https://betatwo.novagems.io/api/'
  // }
  // apiURL:{
  //   baseUrl: 'https://templive.novagems.io/api/superadmin',
  //   systemAnalyticsApis: '',
  //   apinode18: 'https://apitemplive.novagems.io/v1/',
  //   serverUrl: 'https://templive.novagems.io/api/',
  //   newBaseUrl:'https://apitemplive.novagems.io/v1/superAdmin',
  //   payrollUpdateBaseUrl: 'https://apitemplive.novagems.io/'
  // }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts